//Caso retorne sem nenhum resultado, utilize buscaSemResultado
export const buscaSemResultado = "Nenhum registro encontrado.";

//Caso tenha um botão filtrar em conjunto aos campos de entrada, coloque buscaFiltrarVazio
export const buscaFiltrarVazio = "Informe os dados de filtro e clique em 'Filtrar'";

//Caso tenha um botão baixar em conjunto aos campos de entrada, coloque buscaBaixarVazio
export const buscaBaixarVazio = "Informe os dados de filtro e clique em 'Baixar'";

//Caso os campos de entrada buscam automaticamente (sem precisar apertar o botão filtrar) use buscaAutoVazio
export const buscaAutoVazio = "Informe os dados de filtro";

//Para containers em consultas -> containers, é necessário preencher ao menos um dos campos para pesquisar
export const filtrosVaziosContainer = "Preencha um dos campos acima e clique em 'Filtrar'"

//Para validação de campos obrigatórios ao salvar
export const dadosInvalidos = "Existem dados inválidos no formulário. Favor verificar";

//Aviso de campo obrigatório
export const campoObrigatorio = "Campo obrigatório";


// WEBPACK FOOTER //
// ./src/utils/mensagens.js